module.exports = __webpack_public_path__ + "img/ia-01-2.f8b90d56.jpg";